module.exports = __webpack_public_path__ + "img/confirm-btn.da37de03.png";